<template>
  <div id="join-step" class="text-center">
    <h2 class="text-center">{{ $t('joinUs') }}</h2>
    <div class="list">
      <div v-for="(step,index) in $t('stepList')" class="item">
        <img :src="'/static/img/affiliate/img_' + (index + 1) + '.png'" alt="">
        <h3>{{ $t('step') }} {{ index+1 }}</h3>
        <p class="little-title">{{ step.title }}</p>
        <p class="describe">{{ step.detailDescribe }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import locales from './lang'

  export default {
    name: 'affiliate-join-step',
    locales
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  * {
    padding: 0;
    margin: 0;
  }

  #join-step {
    margin-top: 180px;
  }

  h2 {
    font-size: 40px;
    color: #111111;
    letter-spacing: 2px;
    line-height: 40px;
    font-weight: 600;
    padding-bottom: 24px;
    background: linear-gradient(125deg, #416CF8 0%, #EC55FF 100%) center bottom / 60px 4px no-repeat;
  }

  .list {
    margin-top: 80px;
    display: flex;
    justify-content: space-between;
    .item {
      width: 30%;
      img {
        width: 60%;
      }
      h3 {
        margin: 40px 0 24px;
        font-size: 32px;
        color: #000000;
        line-height: 48px;
        font-weight: 600;
        padding-bottom: 16px;
        background: linear-gradient(125deg, #416CF8 0%, #EC55FF 100%) center bottom / 32px 4px no-repeat;
      }

      .little-title {
        font-size: 24px;
        color: #333333;
        line-height: 32px;
        font-weight: 600;
      }
      .describe {
        margin-top: 16px;
        font-size: 16px;
        color: #666666;
        line-height: 22px;
      }
    }
  }

  @media (max-width: 911px) {
    #join-step {
      margin-top: 80px;
    }
  }

  @media (max-width: 767px){
    h2 {
      font-size: 24px;
      line-height: 32px;
      padding-bottom: 16px;
      background-size: 40px 4px;
    }
    .list {
      margin-top: 0;
      display: block;
      .item {
        width: 100%;
        margin-top: 40px;
        overflow: auto;
        img {
          width: 60%;
        }
        h3 {
          margin: 24px 0 16px;
          font-size: 20px;
          line-height: 28px;
        }
        .little-title {
          font-size: 18px;
          line-height: 24px;
        }
        .describe {
          font-size: 14px;
          line-height: 20px;
          margin: 8px 0 40px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// JoinStep.vue?5c531ddf